var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_30420)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 81,
    height: 81,
    rx: 40.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 56.0938C36 56.0938 29.9062 50 29.9062 42.5C29.9062 35 36 28.9062 43.5 28.9062C51 28.9062 57.0938 35 57.0938 42.5C57.0938 50 51 56.0938 43.5 56.0938ZM43.5 31.7188C37.5562 31.7188 32.7188 36.5562 32.7188 42.5C32.7188 48.4438 37.5562 53.2812 43.5 53.2812C49.4438 53.2812 54.2812 48.4438 54.2812 42.5C54.2812 36.5562 49.4438 31.7188 43.5 31.7188Z",
    fill: "url(#paint0_linear_20_30420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 63.05C42.4688 63.05 41.625 62.2812 41.625 61.25V61.1C41.625 60.0687 42.4688 59.225 43.5 59.225C44.5312 59.225 45.375 60.0687 45.375 61.1C45.375 62.1312 44.5312 63.05 43.5 63.05ZM56.8875 57.7625C56.4 57.7625 55.9313 57.575 55.5563 57.2188L55.3125 56.975C54.5812 56.2437 54.5812 55.0625 55.3125 54.3312C56.0437 53.6 57.225 53.6 57.9562 54.3312L58.2 54.575C58.9313 55.3063 58.9313 56.4875 58.2 57.2188C57.8438 57.575 57.375 57.7625 56.8875 57.7625ZM30.1125 57.7625C29.625 57.7625 29.1562 57.575 28.7812 57.2188C28.05 56.4875 28.05 55.3063 28.7812 54.575L29.025 54.3312C29.7563 53.6 30.9375 53.6 31.6687 54.3312C32.4 55.0625 32.4 56.2437 31.6687 56.975L31.425 57.2188C31.0687 57.575 30.5813 57.7625 30.1125 57.7625ZM62.25 44.375H62.1C61.0687 44.375 60.225 43.5312 60.225 42.5C60.225 41.4688 61.0687 40.625 62.1 40.625C63.1312 40.625 64.05 41.4688 64.05 42.5C64.05 43.5312 63.2812 44.375 62.25 44.375ZM24.9 44.375H24.75C23.7188 44.375 22.875 43.5312 22.875 42.5C22.875 41.4688 23.7188 40.625 24.75 40.625C25.7812 40.625 26.7 41.4688 26.7 42.5C26.7 43.5312 25.9312 44.375 24.9 44.375ZM56.6437 31.2312C56.1562 31.2312 55.6875 31.0437 55.3125 30.6875C54.5812 29.9562 54.5812 28.775 55.3125 28.0437L55.5563 27.8C56.2875 27.0687 57.4688 27.0687 58.2 27.8C58.9313 28.5312 58.9313 29.7125 58.2 30.4438L57.9562 30.6875C57.6 31.0437 57.1313 31.2312 56.6437 31.2312ZM30.3562 31.2312C29.8687 31.2312 29.4 31.0437 29.025 30.6875L28.7812 30.425C28.05 29.6937 28.05 28.5125 28.7812 27.7812C29.5125 27.05 30.6937 27.05 31.425 27.7812L31.6687 28.025C32.4 28.7563 32.4 29.9375 31.6687 30.6687C31.3125 31.0437 30.825 31.2312 30.3562 31.2312ZM43.5 25.7C42.4688 25.7 41.625 24.9312 41.625 23.9V23.75C41.625 22.7188 42.4688 21.875 43.5 21.875C44.5312 21.875 45.375 22.7188 45.375 23.75C45.375 24.7812 44.5312 25.7 43.5 25.7Z",
    fill: "url(#paint1_linear_20_30420)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_30420",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_30420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_30420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_30420",
    x1: 43.5,
    y1: 28.9062,
    x2: 43.5,
    y2: 56.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_30420",
    x1: 43.4625,
    y1: 21.875,
    x2: 43.4625,
    y2: 63.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyicon);
export default __webpack_public_path__ + "static/media/energyicon.5629ce9a0c6bd7dfc7e8a7d8c751c961.svg";
export { ForwardRef as ReactComponent };